module.exports = __webpack_public_path__ + "img/3-reunions_view.9d1419dc.jpg";